import React from 'react'
import { Link as GatsbyLink, withPrefix } from 'gatsby'
import { getCurrentLanguage } from 'utils/language'

const Link = ({ children, to, activeClassName, ...other }) => {
  const netlifyLinkReg = /\((.*?)\)/g
  // Ex : (/about)              => /about
  //      /about                => /about
  //      (https://tungtung.vn) => https://tungtung.vn
  to = netlifyLinkReg.test(to)
    ? to.match(netlifyLinkReg)[0].replace(/\(|\)/g, '')
    : to
  const internal = /^\/(?!\/)/.test(to)
  if (internal) {
    // let lang = getBrowserLanguage() // Current Browser Language
    // if (lang.indexOf('-') !== -1) lang = lang.split('-')[0] // Convert 'en-US' to 'en'
    // if (lang.indexOf('_') !== -1) lang = lang.split('_')[0] // Convert 'en-US' to 'en'
    // lang = localStorage.getItem('language') || lang // userCustomLanguage || browserLanguage
    to = withPrefix(`/${getCurrentLanguage()}/${to}`) // New url with language prefix
    return (
      <GatsbyLink to={to} activeClassName={activeClassName} {...other} rel='noopener'>
        {children}
      </GatsbyLink>
    )
  }
  return (
    <a href={to} {...other} rel='noopener'>
      {children}
    </a>
  )
}

export default Link
